import array from '@mailobj-browser/front/js/utils/array.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'

export default (name, target = defaults.document) => {
  const { ownerDocument } = target
  const { content } = one(`meta[name="ea_${name}"]`, ownerDocument ?? target)
  
  return array(content.split(';'))
}
